var CorrectDomains = /*#__PURE__*/function (CorrectDomains) {
  CorrectDomains["AOL"] = "aol.com";
  CorrectDomains["YAHOO"] = "yahoo.com";
  CorrectDomains["COMCAST"] = "comcast.net";
  CorrectDomains["GMAIL"] = "gmail.com";
  CorrectDomains["HOTMAIL"] = "hotmail.com";
  CorrectDomains["ICLOUD"] = "icloud.com";
  CorrectDomains["MSN"] = "msn.com";
  CorrectDomains["OUTLOOK"] = "outlook.com";
  CorrectDomains["VERIZON"] = "verizon.net";
  return CorrectDomains;
}(CorrectDomains || {});
export var wrongDomains = {
  // Aol
  'al.com': CorrectDomains.AOL,
  'ao.com': CorrectDomains.AOL,
  'aol.co': CorrectDomains.AOL,
  'ail.com': CorrectDomains.AOL,
  'a0l.com': CorrectDomains.AOL,
  'aol.con': CorrectDomains.AOL,
  'aol.dom': CorrectDomains.AOL,
  'sol.com': CorrectDomains.AOL,
  'aol..com': CorrectDomains.AOL,
  'aol.com.': CorrectDomains.AOL,
  // Gmail
  'gmail.': CorrectDomains.GMAIL,
  'gmail.c': CorrectDomains.GMAIL,
  'gmail.ca': CorrectDomains.GMAIL,
  'gmail.cm': CorrectDomains.GMAIL,
  'gmail.co': CorrectDomains.GMAIL,
  'gmail.om': CorrectDomains.GMAIL,
  'gmal.com': CorrectDomains.GMAIL,
  'gmil.com': CorrectDomains.GMAIL,
  'gail.com': CorrectDomains.GMAIL,
  'gmai.com': CorrectDomains.GMAIL,
  'gmail.cim': CorrectDomains.GMAIL,
  'gmaik.com': CorrectDomains.GMAIL,
  'gamil.com': CorrectDomains.GMAIL,
  'gmail.c0m': CorrectDomains.GMAIL,
  'gmail.clm': CorrectDomains.GMAIL,
  'gmail.cok': CorrectDomains.GMAIL,
  'gmail.con': CorrectDomains.GMAIL,
  'gmail.cpm': CorrectDomains.GMAIL,
  'gmail.edu': CorrectDomains.GMAIL,
  'gmail.ocm': CorrectDomains.GMAIL,
  'gmail.org': CorrectDomains.GMAIL,
  'gmail.vom': CorrectDomains.GMAIL,
  'gmail.xom': CorrectDomains.GMAIL,
  'gmailc.om': CorrectDomains.GMAIL,
  'gmsil.com': CorrectDomains.GMAIL,
  'gmaio.com': CorrectDomains.GMAIL,
  'gmzil.com': CorrectDomains.GMAIL,
  'gmaol.com': CorrectDomains.GMAIL,
  'gmial.com': CorrectDomains.GMAIL,
  'gamail.com': CorrectDomains.GMAIL,
  'ggmail.com': CorrectDomains.GMAIL,
  'gmaail.com': CorrectDomains.GMAIL,
  'gmaiil.com': CorrectDomains.GMAIL,
  'gmail..com': CorrectDomains.GMAIL,
  'gmail.ccom': CorrectDomains.GMAIL,
  'gmail.com.': CorrectDomains.GMAIL,
  'gmail.com3': CorrectDomains.GMAIL,
  'gmail.come': CorrectDomains.GMAIL,
  'gmail.comm': CorrectDomains.GMAIL,
  'gmail.comn': CorrectDomains.GMAIL,
  'gmail.conm': CorrectDomains.GMAIL,
  'gmail.coom': CorrectDomains.GMAIL,
  'gmaill.com': CorrectDomains.GMAIL,
  'gmailo.com': CorrectDomains.GMAIL,
  'gmaiul.com': CorrectDomains.GMAIL,
  'gmmail.com': CorrectDomains.GMAIL,
  'gmnail.com': CorrectDomains.GMAIL,
  'gnmail.com': CorrectDomains.GMAIL,
  'gmail.iu.edu': CorrectDomains.GMAIL,
  'googlemail.com': CorrectDomains.GMAIL,
  // Hotmail
  'homail.com': CorrectDomains.HOTMAIL,
  'hotail.com': CorrectDomains.HOTMAIL,
  'hotmai.com': CorrectDomains.HOTMAIL,
  'hotmail.co': CorrectDomains.HOTMAIL,
  'hotmil.com': CorrectDomains.HOTMAIL,
  'htmail.com': CorrectDomains.HOTMAIL,
  'h0tmail.com': CorrectDomains.HOTMAIL,
  'hitmail.com': CorrectDomains.HOTMAIL,
  'homtail.com': CorrectDomains.HOTMAIL,
  'hotamil.com': CorrectDomains.HOTMAIL,
  'hotmail.c0m': CorrectDomains.HOTMAIL,
  'hotmail.con': CorrectDomains.HOTMAIL,
  'hotmial.com': CorrectDomains.HOTMAIL,
  'htomail.com': CorrectDomains.HOTMAIL,
  'hoitmail.com': CorrectDomains.HOTMAIL,
  'hotmaiil.com': CorrectDomains.HOTMAIL,
  'hotmail..com': CorrectDomains.HOTMAIL,
  'hotmail.ccom': CorrectDomains.HOTMAIL,
  'hotmail.com.': CorrectDomains.HOTMAIL,
  'hotmail.comi': CorrectDomains.HOTMAIL,
  'hotmail.comm': CorrectDomains.HOTMAIL,
  'hotmaill.com': CorrectDomains.HOTMAIL,
  'hotmailo.com': CorrectDomains.HOTMAIL,
  // Msn
  'msm.com': CorrectDomains.MSN,
  // Icloud
  'icloud.con': CorrectDomains.ICLOUD,
  'icould.com': CorrectDomains.ICLOUD,
  // Comcast
  'comast.net': CorrectDomains.COMCAST,
  // Outlook
  'outlook.om': CorrectDomains.OUTLOOK,
  'outlook.con': CorrectDomains.OUTLOOK,
  // Verizon
  'verison.net': CorrectDomains.VERIZON,
  'verzion.net': CorrectDomains.VERIZON,
  'verizion.net': CorrectDomains.VERIZON,
  // Yahoo
  'yaho.com': CorrectDomains.YAHOO,
  'yahoo.cm': CorrectDomains.YAHOO,
  'yahoo.co': CorrectDomains.YAHOO,
  'yahoo.om': CorrectDomains.YAHOO,
  'yaoo.com': CorrectDomains.YAHOO,
  'yhoo.com': CorrectDomains.YAHOO,
  'ahoo.com': CorrectDomains.YAHOO,
  'yahoo.vom': CorrectDomains.YAHOO,
  'tahoo.com': CorrectDomains.YAHOO,
  'yah00.com': CorrectDomains.YAHOO,
  'yahho.com': CorrectDomains.YAHOO,
  'yahol.com': CorrectDomains.YAHOO,
  'yahoo.c0m': CorrectDomains.YAHOO,
  'yahoo.cim': CorrectDomains.YAHOO,
  'yahoo.con': CorrectDomains.YAHOO,
  'yayoo.com': CorrectDomains.YAHOO,
  'yhaoo.com': CorrectDomains.YAHOO,
  'yshoo.com': CorrectDomains.YAHOO,
  'yahool.com': CorrectDomains.YAHOO,
  'yahooo.com': CorrectDomains.YAHOO,
  'yahhoo.com': CorrectDomains.YAHOO,
  'yaahoo.com': CorrectDomains.YAHOO,
  'yahoio.com': CorrectDomains.YAHOO,
  'yahoo..com': CorrectDomains.YAHOO,
  'yahoo.com.': CorrectDomains.YAHOO,
  'yahoo.com3': CorrectDomains.YAHOO,
  'yahoo.comS': CorrectDomains.YAHOO,
  'yahoo.comm': CorrectDomains.YAHOO,
  'yahoo.conm': CorrectDomains.YAHOO,
  'yahoo.coom': CorrectDomains.YAHOO,
  'yyahoo.com': CorrectDomains.YAHOO
};
export function validateDomain(email) {
  var emailParts = email.split('@');
  var domain = emailParts[1];
  return domain !== undefined && wrongDomains[domain];
}